import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const SearchIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path
      fillRule="evenodd"
      d="M16.31 18.017A9.459 9.459 0 0 1 10.5 20a9.5 9.5 0 1 1 6.57-2.638l4.784 4.784a.5.5 0 0 1-.708.708l-4.836-4.837ZM19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Z"
    />
  </IconWrapper>
)

export default SearchIconMedium
